import { useState, useEffect, Dispatch, SetStateAction } from 'react'
import { Item } from '../../../../../../../utils/types/generals'
import { InputModel } from '../../../../../../../utils/types'
import { removeAllReference } from '../../../../../../../utils/methods/removedReference'
import { createEdit, filterCrud, settingInputs } from '../constants/forms'
import { FilterProps } from '../../../../../../../hooks/filter/typing'
import { useFilter } from '../../../../../../../hooks/filter'
import { getArea, getDepartments, getDivisions, getRoles, getStore, getUserTypes } from '../../../../../../../utils/methods/geServiceWithItemsFormat'
import { Roles, Types } from '../../../../../../../utils/enums'
import { userServiceFetch } from '../../../../../../../utils/constants/callService'
import { returnQuery } from '../../../../../../../utils/methods/returnQuery'
import { useTranslation } from 'react-i18next'
import { LoadData, UserLoad } from '../../../../../../questionnaire/pages/permission/fragments/addUsers/types'
const formatFilter = {
  from: "start_date",
  to: 'end_date',
  status: "status_ids",
  role: "role_ids",
  stores: "store_ids",
  userType: "user_type_ids",
  area: "areas_ids",
  department: "departments_ids"
}
const useInput = ({ items, itemsSetting, setUserSelected, userSelected }: { userSelected: Record<string, boolean>; items?: Record<string, Item[]>; itemsSetting?: Record<string, Item[]>; setUserSelected: Dispatch<SetStateAction<Record<string, boolean>>> }) => {
  const { t } = useTranslation()
  const [modalLoad, setModalLoad] = useState<{ open: boolean; tmpUsuers?: Record<string, string | boolean>[] }>({ open: false })
  const [loadings, setLoadings] = useState({ search: false, load: false, table: false, submit: false, main: false })
  const [snackbar, setSnackbar] = useState<{ open: boolean; type: Types; message: string }>({
    open: false,
    message: '',
    type: Types.SUCCESS,
  })
  const [input, setInput] = useState<{ [x: string]: InputModel }>(createEdit)
  const [inputFilter, setInputFilter] = useState<{ [x: string]: InputModel }>(filterCrud)
  const [settingInput, setSettingInput] = useState<{ [x: string]: InputModel }>(settingInputs)
  const [allDepartments, setAllDepartments] = useState<Item[]>([])
  const [inputCreate, setInputCreate] = useState({
    search: {
      label: 'general.searchUsers',
      translate: true,
      name: 'search',
      value: null,
    },
    from: {
      label: 'general.tags.from',
      translate: true,
      name: 'from',
      type: 'date',
      value: null,
      rest: {
        max: 'to',
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6,
      },
    },
    to: {
      label: 'general.tags.to',
      translate: true,
      name: 'to',
      type: 'date',
      value: null,
      rest: {
        min: 'from',
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6,
      },
    },
    role: {
      label: 'general.tags.role',
      translate: true,
      name: 'role',
      type: 'filter-select',
      items: [],
      value: null,
    },
    stores: {
      label: 'general.tags.store',
      translate: true,
      name: 'stores',
      type: 'filter-select',
      items: [],
      value: null,
    },
    division_ids: {
      label: 'general.tags.divisions',
      translate: true,
      name: 'division_ids',
      type: 'filter-select',
      items: [],
      value: null,
    },
    userType: {
      label: 'general.tags.userType',
      translate: true,
      name: 'userType',
      type: 'filter-select',
      items: [],
      value: null,
    },
    area: {
      label: 'general.tags.area',
      translate: true,
      name: 'area',
      type: 'filter-select',
      items: [],
      value: null,
    },
    department: {
      label: 'general.tags.department',
      translate: true,
      name: 'department',
      type: 'filter-select',
      items: [],
      value: null,
    },
  } as { [x: string]: InputModel })
  const externalValidation: FilterProps['externalValidation'] = ({ name, body, setFilterData }) => {
    let copyBody: Record<string, any> = removeAllReference(body)

    if (name === 'area') {
      const { area, department } = copyBody
      const newDepartments = department?.filter((e: any) => area.find((e2: any) => e2.value == e.areaId))
      let arrayChilds: any[] = []

      area?.forEach((e: any) => {
        const id = e.value
        const childs = allDepartments.filter((child) => child.areaId == id)
        arrayChilds.push(...childs)
      })

      setFilterData((prev) => ({
        ...prev,
        department: newDepartments,
      }))

      setInputCreate(prev => ({ ...prev, department: { ...prev.department, items: arrayChilds } }))
      copyBody = {
        ...copyBody,
        department: newDepartments,
      }
    }

    return copyBody
  }
  const createFilter = useFilter({
    formatFilter,
    externalValidation,
    defaultPagination: { pageSize: 500 }
  })
  const disabledInputs = (data: { inputs: string[]; value: boolean }) => {
    let copyInput: {
      [x: string]: InputModel
    } = removeAllReference(input)

    data?.inputs?.forEach((item) => {
      copyInput[item] = {
        ...copyInput[item],
        rest: {
          ...(copyInput[item]?.rest ?? {}),
          disabled: data.value,
        },
      }
    })

    setInput((prev) => ({
      ...prev,
      ...copyInput,
    }))
  }


  const searchUsers = async () => {
    try {
      setLoadings(prev => ({ ...prev, search: true }))
      const response = await userServiceFetch.filterUsers({ query: `status_ids=1&${returnQuery(createFilter.query, {})}` })
      let allUsers: Record<string, string | boolean>[] = response?.map(item => ({
        id: item.id.toString(),
        users: item.fullName,
        userType: item.userType ?? '',
        division: item.division,
        role: item.role ?? '',
        curp: item.curp ?? ''
      })) ?? []
      if (!!allUsers?.length) {
        setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: allUsers }))
      } else {
        setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: [] }))
        setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
      }
    } catch (e) {
      setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: [] }))
      setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
    }
    finally {
      setLoadings(prev => ({ ...prev, search: false }))
    }
  }
  const cancelSearchUsers = () => {
    createFilter.cleanFilter()
    setModalLoad(prev => ({ ...prev, open: false, tmpUsuers: [] }))
    setLoadings(prev => ({ ...prev, search: false }))
  }
  const getAllDepartments = async () => {
    const items = await getDepartments()
    setAllDepartments(items)
  }

  const getAllUnits = async () => {
    const { items } = await getStore()
    setInputCreate(prev => ({ ...prev, stores: { ...prev.stores, items } }))
  }

  const getAllUserTypes = async () => {
    const { items } = await getUserTypes()
    setInputCreate(prev => ({ ...prev, userType: { ...prev.userType, items } }))
    // setInput(prev => ({
    //   ...prev,
    //   userType: {
    //     ...prev.userType,
    //     items: items ?? [],
    //   },
    // }))
  }

  const getAllRoles = async () => {
    const { items } = await getRoles({ skip: [Roles.ADMIN] })

    setInputCreate(prev => ({ ...prev, role: { ...prev.role, items } }))

    // setInput(prev => ({
    //   ...prev,
    //   role: {
    //     ...prev.role,
    //     items: items ?? [],
    //   },
    // }))
  }

  const getAlDivisions = async () => {
    const { items } = await getDivisions()
    setInputCreate(prev => ({ ...prev, division_ids: { ...prev.division_ids, items } }))
  }

  const getAllAreas = async () => {
    const items = await getArea()
    setInputCreate(prev => ({ ...prev, area: { ...prev.area, items: items } }))
  }

  const getData = () => {
    getAllUnits()
    getAllUserTypes()
    getAllRoles()
    getAllAreas()
    getAllDepartments()
    getAlDivisions()
  }

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    let body = {}
    Object.entries(input).forEach(([key, itemInputs]) => {
      body = { ...body, [key]: { ...itemInputs, items: items?.[key] } }
    })

    setInput(body)
    // eslint-disable-next-line
  }, [items])

  const loadUsers: LoadData = (listUsers: UserLoad[], permissons: Record<string, boolean>, success) => {
    setLoadings(prev => ({ ...prev, load: true }))
    let userJson = { ...userSelected }
    let amount = 0
    listUsers?.forEach((user: UserLoad) => {
      if (!userSelected?.[user.id]) {
        amount += 1
        userJson = { ...userJson, [user.id]: true }
      }
    })
    success({ amountOfUserAdded: amount, loadSuccess: !!amount })
    setUserSelected(userJson)
    setLoadings(prev => ({ ...prev, load: false }))

  }
  useEffect(() => {
    let body = {}
    Object.entries(inputFilter).forEach(([key, itemInputs]) => {
      body = { ...body, [key]: { ...itemInputs, items: items?.[key] } }
    })

    setInputFilter(body)
    // eslint-disable-next-line
  }, [items])

  const closeSnackbar = () => { setSnackbar(prev => ({ ...prev, open: false })) }
  useEffect(() => {
    let body = {}
    Object.entries(settingInput).forEach(([key, itemInputs]) => {
      body = { ...body, [key]: { ...itemInputs, items: itemsSetting?.[key] } }
    })

    setSettingInput(body)
    // eslint-disable-next-line
  }, [itemsSetting])
  return { input, settingInput, inputFilter, cancelSearchUsers, disabledInputs, setSnackbar, searchUsers, closeSnackbar, loadUsers, snackbar, loadings, modalLoad, createFilter, inputCreate }
}

export { useInput }
